import { Vue, Component } from 'vue-property-decorator';
import { LsReport } from '@/Components/LSReport';
import { FullScreenToggle } from '@samc/centricity-core';

import '@/registerVuePlugins';

@Component({
  name: 'ReportingView',
  components: { LsReport, FullScreenToggle }
})
class ReportingViewComponent extends Vue {
}

new ReportingViewComponent()
  .$mount('#reporting-view');